// src/hooks/useDateSpeaker.js
import {useQuery} from 'react-query';
import {fetchDateSpeakerList} from "../api/dateSpeakerApi";

export const useDateSpeaker = () => {
    return useQuery(['dateSpeaker'], () => fetchDateSpeakerList(), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};
